import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service11 from './Service11';
import Service11Second from './Service11Second';
import ReservationForm from './ReservationForm';


import Footer from './Footer';


const Awrudhu = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service11 />
            <Service11Second />

            <ReservationForm />

            <Footer/>

        </div>
    );
};

export default Awrudhu;